import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { StoneAbove, StoneBelow } from './StoneTables';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { DefaultButton } from 'office-ui-fabric-react/lib-commonjs/Button';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import './index.css';
import { Button } from 'primereact/button';

class PopUpHelperComponent extends PureComponent {
  state = {
    changeColor: true,
    toggleModal: false,
    toggleBubble: false,
  };

  render() {
    const { lang, text, type, show, title, image, content, chamber, modalSize, hideModal, modalActions } = this.props;

    const { changeColor, toggleBubble } = this.state;

    // const examplePrimaryButton: IButtonProps = {
    //   children: 'Try it out'
    // };

    const OnDismiss = () => {
      this.setState({ toggleBubble: !toggleBubble });
    };

    // const secondaryButtonProps = {
    //   children: 'Close',
    //   onClick: OnDismiss
    // };

    const changeColors = (value) => {
      this.setState({ changeColor: value });
    };

    const stoneTables = {
      STONE_ABOVE_TABLE: <StoneAbove />,
      STONE_BELOW_TABLE: <StoneBelow />,
    };

    switch (type) {
      case 'crossSectionBtn':
        return (
          <div>
            <Button
              label={content[lang].crossSectionDetail}
              onClick={OnDismiss}
              style={{
                marginLeft: '5px',
              }}
            />
            {toggleBubble ? (
              <Modal isBlocking={false} onDismiss={OnDismiss} isOpen={toggleBubble} containerClassName={css.container}>
                <div className="ms-fontColor-black" style={css.title}>
                  <div style={{ fontWeight: 'bold' }}>{title}</div>
                  <div className="xButton" onClick={OnDismiss}>
                    <Icon iconName="CalculatorMultiply" />
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <img src={image} alt={image} style={css.img} />
                </div>
                <div className="ms-fontColor-black" style={css.contentImg}>
                  {text}
                </div>
              </Modal>
            ) : null}
          </div>
        );

      case 'crossSection':
        return (
          <div ref={(menuButton) => (this._menuButtonElement = menuButton)} onClick={OnDismiss}>
            <img src={chamber} alt={chamber} style={{ cursor: 'pointer', width: '140px', height: '105px' }} />
            {toggleBubble ? (
              <Modal isBlocking={false} onDismiss={OnDismiss} isOpen={toggleBubble} containerClassName={css.container}>
                <div className="ms-fontColor-black" style={css.title}>
                  <div style={{ fontWeight: 'bold' }}>{title}</div>
                  <div className="xButton" onClick={OnDismiss}>
                    <Icon iconName="CalculatorMultiply" />
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <img src={image} alt={image} style={css.img} />
                </div>
                <div className="ms-fontColor-black" style={css.contentImg}>
                  {text}
                </div>
              </Modal>
            ) : null}
          </div>
        );
      case 'alert':
        return (
          <Modal
            isOpen={show}
            isBlocking={false}
            onDismiss={hideModal}
            containerClassName={modalSize !== 'mid' ? css.miniModal : css.midModal}>
            <div className="ms-fontColor-black" style={{ textAlign: 'center' }}>
              <div
                style={
                  modalSize !== 'mid'
                    ? { textAlign: 'center', margin: '0 20px 0 20px' }
                    : { textAlign: 'justify', margin: '0 20px 0 20px' }
                }>
                <br />
                <br /> {text}{' '}
                {modalSize !== 'mid' ? (
                  <div>
                    <br />
                    <br />
                  </div>
                ) : (
                  <br />
                )}
              </div>
              <DefaultButton
                text={title}
                onClick={modalActions}
                style={{ border: 'solid 1px white' }}
                primary={modalSize !== 'mid' ? true : false}
              />{' '}
              &nbsp; &nbsp;
              {modalSize !== 'mid' ? (
                <DefaultButton text={content[lang].cancel} onClick={hideModal} className={'outline_grey_ads'} />
              ) : null}
            </div>
          </Modal>
        );
      default:
        return (
          <div
            onClick={OnDismiss}
            onMouseLeave={() => changeColors(true)}
            onMouseEnter={() => changeColors(false)}
            style={changeColor ? css.default : css.changed}
            ref={(menuButton) => (this._menuButtonElement = menuButton)}>
            &nbsp;?&nbsp;
            {toggleBubble ? (
              <TeachingBubble
                headline={title}
                hasCloseIcon={true}
                onDismiss={OnDismiss}
                hasSmallHeadline={true}
                hasCondensedHeadline={true}
                closeButtonAriaLabel="Close"
                targetElement={this._menuButtonElement}>
                {image !== null ? stoneTables[image] : null}
                {text}
              </TeachingBubble>
            ) : null}
          </div>
        );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,
  };
};

export default connect(mapStateToProps, {})(PopUpHelperComponent);

const css = {
  default: {
    color: '#fff',
    cursor: 'pointer',
    paddingTop: '5px',
    fontWeight: 'bold',
    borderRadius: '8px',
    backgroundColor: '#0C92CD',
  },
  changed: {
    color: '#fff',
    cursor: 'pointer',
    paddingTop: '5px',
    fontWeight: 'bold',
    borderRadius: '8px',
    backgroundColor: '#55cbff',
  },
  container: {
    minWidth: '1100px',
    maxWidth: '1200px',
    minHeight: '545px',
    maxHeight: '650px',
    backgroundColor: 'white',
  },
  miniModal: {
    minWidth: '450px',
    maxWidth: '450px',
    minHeight: '150px',
    maxHeight: '150px',
    backgroundColor: 'white',
  },
  midModal: {
    minWidth: '450px',
    maxWidth: '450px',
    minHeight: '250px',
    maxHeight: '250px',
    backgroundColor: 'white',
  },
  title: {
    padding: '13px',
    fontSize: '30px',
    display: 'block',
  },
  content: {
    minWidth: '1066px',
    maxWidth: '1066px',
    paddingTop: '10px',
    paddingLeft: '16px',
    textAlign: 'justify',
  },
  contentImg: {
    width: '98%',
    paddingTop: '10px',
    paddingLeft: '16px',
    textAlign: 'justify',
  },
  xButton: {
    textAlign: 'right',
    marginTop: '-45px',
    marginRight: '-5px',
  },
  xButtonChanged: {
    color: 'black',
    cursor: 'pointer',
    textAlign: 'right',
    marginTop: '-45px',
    marginRight: '-5px',
  },
  img: {
    width: '98%',
  },
};



// WEBPACK FOOTER //
// ./src/components/Calculations/popUpHelper.component.js